<template>
  <main>
    <section class="file-container my-10">
      <h3
        style="
          color: #000;
          font-weight: 500;
          font-family: cairo;
          cursor: pointer;
        "
      >
        <slot></slot>
      </h3>

      <div @click="onFileClick" class="uploadphoto upload-class">
        <v-icon color="#0b7477">mdi-microphone</v-icon>
        <img
          src="../../assets/media/images/music-file.png"
          alt="Image To Upload"
          width="100"
          height="100"
          class="image_placeholder"
        />
      </div>

      <div class="image-wrapper" ref="imageWrapper">
        <div
          class="image-preview"
          v-for="(audioUrl, index) in audioUrls"
          :key="index"
        >
          <audio
            :src="audioUrl.path || audioUrl"
            controls
            style="width: 200px"
          ></audio>
        </div>
      </div>
    </section>

    <input
      @change="onFileSelect"
      :multiple="multiple"
      type="file"
      hidden
      ref="file_input"
      :accept="accept"
    />
  </main>
</template>

<script>
export default {
  name: "AudioUpload",
  props: {
    accept: {
      type: String,
      default: "audio/*",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    urls: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasNewFile: false,

      files: [],
    };
  },
  computed: {
    audioUrls() {
      if (this.hasNewFile) {
        console.log("hello");
        const audioFiles = this.files.filter((file) =>
          file.type.startsWith("audio/")
        );
        return audioFiles.map((file) => URL.createObjectURL(file));
      } else {
        return this.urls;
      }
    },
  },
  methods: {
    onRemove(index) {
      if (this.files && this.files[index] && this.files[index]["type"]) {
        this.$delete(this.files, index);
      } else {
        this.$emit("onFileRemove", index);
      }
    },
    onFileClick() {
      if (this.disabled) return;
      this.$refs.file_input.value = "";
      this.$refs.file_input.click();
    },
    onFileSelect(event) {
      const selected = Array.from(event.target.files);
      this.files = selected.slice(0, 1);
      this.hasNewFile = true;
      console.log("files", this.files);
      this.$emit("selectAudio", this.files);
    },
  },
};
</script>

<style scoped>
.file-container {
  position: relative;
}

.uploadphoto {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.image-wrapper {
  max-width: 100%;
  overflow-x: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center !important;

  gap: 10px;
  margin-top: 10px;
  padding-inline: 10px;
}

.image-preview {
  position: relative;
  transition: all 1s ease;
}

.remove-file {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  color: white;
  top: 5px;
  left: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  border-radius: 8px;
  transition: all 0.6s ease;
}

.image-preview:hover .overlay {
  opacity: 1;
}
</style>
